import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { ContextMenu, MenuButton } from 'basic-components';
import { FatArrowDown } from 'basic-components/icons';
import { globalActions } from 'primary-components';

import ProviderIcon from './ProviderIcon';
import ProviderItem from './ProviderItem';
import ProviderLabel from './ProviderLabel';

import { Else, If, Then, When } from 'react-if';

const EMPTY_ARRAY = []
const ProviderSelector = ({ withText = true, menuGap = undefined }) => {
  const dispatch = useDispatch(),
        source = useSelector(state => state.globalState.localSource),
        sources = useSelector(state => state.globalState.sources) || EMPTY_ARRAY,
        onChangeProvider = useCallback(source => dispatch(globalActions.onChange(source, "localSource")), [dispatch]),
        localProvider = useMemo(() => sources.find(p => p.producerId === 0), [sources]),
        activeProvider = useMemo(() => sources.find(p => p.name === source) || {}, [source, sources])

  useEffect(() => {
    if(!source && localProvider?.name) {
      onChangeProvider(localProvider.name)
    }
  }, [localProvider, onChangeProvider, source])

  return (
    <ContextMenu
        className="provider-selector__menu"
        gap={menuGap}
        menuButton={(
          <MenuButton
              aria-label={`Source selection ${activeProvider.readableName}`}
              key="MenuButton"
          >
            <div className="provider-selector">
              <When condition={withText}>
                {() => (
                  <ProviderLabel/>
                )}
              </When>
              <ProviderIcon activeProvider={activeProvider}/>
              <If condition={withText}>
                <Then>
                  {() => (
                    <div className="provider-selector__name">
                      {activeProvider.readableName}
                    </div>
                  )}
                </Then>
                <Else>
                  {() => (
                    <div className="provider-selector__arrow">
                      <FatArrowDown
                          color="blue-bright"
                          height={12}
                          width={12}
                      />
                    </div>
                  )}
                </Else>
              </If>
            </div>
          </MenuButton>
        )}
    >
      {sources.map((provider, pIndex) => (
        <ProviderItem
            key={pIndex}
            onChangeProvider={onChangeProvider}
            provider={provider}
        />
      ))}
    </ContextMenu>
  )
}

  ProviderSelector.propTypes = {
    menuGap: PropTypes.number,
    withText: PropTypes.bool,
  }

export default ProviderSelector;